<template>
  <div>
    <h3 class="h3-responsive">Нэхэмжлэх бүртгэлийн жагсаалт</h3>
    <Toast position="bottom-right" />

    <!-- configration dialog -->
    <Dialog
      header="Анхааруулга"
      :visible.sync="displayDelete"
      :style="{ width: '505px' }"
      :modal="true"
    >
      <template #header></template>
      <div class="confirmation-content">
        <i
          class="pi pi-exclamation-triangle p-mr-3"
          style="font-size: 2rem; margin-right: 0.5em; color: red"
        />
        <span
          >Та {{ this.invoiceId }} дугаартай захиалгат үйлчилгээг устгахдаа
          итгэлтэй байна уу ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          @click="actionDialog('no', null)"
          class="p-button-danger p-button-text"
        />
        <Button
          label="Тийм"
          icon="pi pi-check"
          @click="actionDialog('yes', null)"
          class="p-button-danger p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <!-- diaglog for register and update contract -->
    <Dialog
      :visible.sync="displayModal"
      :style="{ width: '70vw' }"
      :modal="true"
    >
      <template #header>
        <h3 class="h3-responsive">{{ modalTitle }}</h3>
      </template>

      <div class="p-grid">
        <div class="p-col">
          <h5 class="h5-responsive">Төлөгчийн мэдээлэл:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-4 offset-4">
              <label for="type">Байгууллагын нэр:</label>
              <InputText
                id="type"
                type="text"
                class="form-control"
                v-model.trim="$v.type.$model"
                :class="{
                  'is-invalid': $v.type.$error,
                  'is-valid': !$v.type.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">
                Захиалгат үйлчилгээний төрөл оруулсан!
              </div>
              <div class="invalid-feedback">
                <span v-if="!$v.type.required">
                  Захиалгат үйлчилгээний төрөлийг оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="price">Регистрийн №:</label>
              <InputText
                id="price"
                type="text"
                v-model.trim="$v.price.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.price.$error,
                  'is-valid': !$v.price.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Төлбөр оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.price.required">Төлбөр оруулна уу.</span>
                <span v-if="!$v.price.numeric"
                  >Зөвхөн тоон утаг оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-12">
              <DataTable
                :value="invoiceItems"
                editMode="cell"                
                @cell-edit-complete="onCellEditComplete"
                class="editable-cells-table" 
              >
                <Column field="Description" header="Гүйлгээний утга">
                  <template #editor="slotProps">
                    <div class="demo-container p-p-1">
                      <Textarea
                        v-model="slotProps.data[slotProps.column.field]"
                        :autoResize="true"
                        rows="1"
                        cols="30"
                      />
                    </div>
                  </template>
                </Column>
                <Column field="Quantity" header="Нэгж/ширхэг" key="Quantity">
                  <template #editor="slotProps">
                    <div class="form-group">
                      <InputNumber
                        v-model="slotProps.data[slotProps.column.field]"
                        @update="onCellEdit($event, slotProps)" 
                        suffix="ш"
                      />
                    </div>
                  </template>
                </Column>
                <Column field="UnitPrice" header="Нэгжийн үнэ">
                  <template #editor="slotProps">
                    <InputNumber
                      v-model="slotProps.data[slotProps.column.field]"
                      suffix="₮"
                    />
                  </template>
                </Column>
                <Column field="TotalPrice" header="Нийт үнэ">
                  <template #editor="slotProps">
                    <InputNumber
                      v-model="slotProps.data[slotProps.column.field]"
                      suffix="₮"
                      :disabled="true"
                    />
                  </template>
                </Column>
                <Column bodyStyle="text-align: center">
                  <template #header="slotProps">
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      class="p-button-success"
                      style="margin-right: 0.5em"
                      @click="actionInvoice('add', slotProps.data)"
                    ></Button>            
                  </template>,
                  <template #body="slotProps">
                    <Button
                      type="button"
                      icon="pi pi-minus"
                      class="p-button-danger"
                      style="margin-right: 0.5em"
                      @click="actionInvoice('remove', slotProps.data)"
                    ></Button>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          class="p-button-danger p-button-text"
          @click="actionModal('no', null)"
        />
        <Button
          label="Хадгалах"
          type="submit"
          icon="pi pi-save"
          class="p-button-success"
          @click="actionModal('save', null)"
          v-show="!viewMode && !viewEdit"
        />
        <Button
          label="Шинэчлэх"
          icon="pi pi-save"
          class="p-button-warning"
          @click="actionModal('update', null)"
          v-show="viewEdit"
          :autofocus="viewEdit"
        />
      </template>
    </Dialog>
    <DataTable
      :value="invoiceList"
      :filters="filters"
      :paginator="true"
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20]"
      :loading="loading"
      class="p-datatable-sm"
    >
      <template #header>
        <div class="p-grid">
          <div class="p-col">
            <div class="box">
              <Button
                label="Нэхэмжлэх бүртгэл"
                class="p-button-success"
                icon="pi pi-plus"
                style="margin: 4px 4px 0px 0px"
                @click="actionModal('new', null)"
              />
            </div>
          </div>
          <div class="p-col" style="text-align: right">
            <div class="box">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  placeholder="Хайлт...."
                  size="40"
                  v-model="filters['global']"
                />
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #empty>Нэхэмжлэх олдсонгүй.</template>
      <template #loading
        >Нэхэмжлэх мэдээллийг ачаалж байна. Түр хүлээнэ үү.</template
      >
      <Column selectionMode="single" headerStyle="width: 3em"></Column>
      <Column
        field="InvoiceNumber"
        header="Нэхэмжлэх №"
        headerStyle="width: 10em"
        bodyStyle="text-align: center"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.InvoiceNumber }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['InvoiceNumber']"
              class="p-column-filter p-inputtext-sm"
              placeholder="Нэхэмжлэх №-гаар хайх"
              style="width: 10em"
            />
          </div>
        </template>
      </Column>
      <Column
        field="CompanyName"
        header="Байгууллагын нэр"
        headerStyle="width: 20em"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.CompanyName }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['CompanyName']"
            class="p-column-filter p-inputtext-sm"
            placeholder="Нэрээр хайх"
            style="width: 10em"
          />
        </template>
      </Column>
      <Column 
        field="RegisterNumber" 
        header="Регистрийн №:"
        headerStyle="width: 20em"
        >
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.RegisterNumber }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['RegisterNumber']"
              class="p-column-filter p-inputtext-sm"
              placeholder="РД №-гаар хайх"
              style="width: 10em"
            />
          </div>
        </template>
      </Column>
      <Column field="InoviceStatus" header="Төлөв:"> 
      </Column>
      <Column field="TotalPrice"  header="Нийт дүн:"> 
        <template #body="slotProps">
          {{ formatCurrency(slotProps.data.TotalPrice) }}
        </template>
      </Column>
      <Column
        headerStyle="width: 15em; text-align: center"
        bodyStyle="width: 40em; text-align: center"
      >
        <template #header>
          <Button type="button" icon="pi pi-cog"></Button> </template
        >,
        <template #body="slotProps">
          <Button
            type="button"
            icon="pi pi-eye"
            class="p-button-primery"
            style="margin-right: 0.5em"
            @click="actionModal('view', slotProps.data)"
            v-tooltip.left="'Харах'"
          ></Button>
          <Button
            type="button"
            icon="pi pi-pencil"
            class="p-button-warning"
            style="margin-right: 0.5em"
            @click="actionModal('edit', slotProps.data)"
            v-tooltip.top="'Засах'"
          ></Button>
          <Button
            type="button"
            icon="pi pi-envelope"
            class="p-button-success"
            style="margin-right: 0.5em"
            @click="actionDialog('email', slotProps.data.Id)"
            v-tooltip.bottom="'И-мэйл-р нэхэмжлэх илгээх'"
          ></Button>
          <Button
            type="button"
            icon="pi pi-star-o"
            class="p-button-danger"
            style="margin-right: 0.5em"
            @click="actionDialog('sms', slotProps.data.Id)"
             v-tooltip.right="'SMS-р нэхэмжлэх илгээх'"
          ></Button>
        </template>
      </Column>
      <template #footer
        >Нийт {{ invoiceList ? invoiceList.length : 0 }} нэхэмжлэх
        байна.</template
      >
    </DataTable>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Toast from "primevue/toast";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";

import { required, numeric } from "vuelidate/lib/validators";

const baseURL = "http://localhost:8080/invoice";



export default {
  name: "FormValidation",
  components: {
    DataTable,
    Column,
    Button,
    InputText,
    InputNumber,
    Toast,
    Dialog,
    Textarea,
  },
  data() {
    return {
      editingCellRows: {},
      editingRows: [],
      maxId: "",
      modalTitle: "",
      invoiceId: "",
      nextId: 0,
      invoiceDate: null,
      invoiceItems: [],
      invoiceList: [],
      errors: [],
      filters: {},
      loading: true,
      displayDelete: false,
      displayModal: false,
      viewMode: false,
      viewEdit: false,
      type: "",
      price: null,
      description: "",
      paymentType: "",
      disabled: 0,
      IsFocus: false,
      IsParents: false,
      open: false,
    };
  },
  validations: {
    type: {
      required,
    },
    price: {
      required,
      numeric,
    },
    unitPrice: {
      required,
    },
    description: {
      required,
    },
    invoiceDate: {
      required,
    },
  },
  async created() {
    try {
      const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted
      await axios
        .all([requestOne])
        .then(
          axios.spread((...responses) => {
            const responseOne = responses[0];
            // use/access the results
            this.invoiceList = responseOne.data;
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
      this.loading = false;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
     onCellEditComplete(event) {

            if (!this.editingCellRows[event.index]) {
                return;
            }
          
             const editingCellValue = this.editingCellRows[event.index][event.field];

             switch (event.field) {
                case 'Quantity':
                case 'UnitPrice':
                    if (this.isPositiveInteger(editingCellValue))
                    {               
                      this.invoiceItems[event.index] = {...this.editingCellRows[event.index]};
                    }                
                    else
                        event.preventDefault();
                break;

                default:
                    if (editingCellValue.trim().length > 0)
                        this.invoiceItems[event.index] = {...this.editingCellRows[event.index]};
                    else
                        event.preventDefault();
                break;
            }
        },
      onCellEdit(newValue, props) {
          if (!this.editingCellRows[props.index]) {
              this.editingCellRows[props.index] = {...props.data};
          }

          this.editingCellRows[props.index][props.column.props.field] = newValue;
      },    
      isPositiveInteger(val) {
        let str = String(val);
        str = str.trim();
        if (!str) {
            return false;
        }
        str = str.replace(/^0+/, "") || "0";
        var n = Math.floor(Number(str));
        return n !== Infinity && String(n) === str && n >= 0;
    },
     actionInvoice(action, data) {
      if (action == "add") {
        this.invoiceItems.push({
          Index: this.nextId++,
          Description: null,
          Quantity: null,
          UnitPrice: null,
          TotalPrice: null,
        });
      } else if(action == "remove") {
        this.invoiceItems.splice(this.invoiceItems.findIndex(function(i){
            return i.Index == data.Index; }), 1);
            console.log(this.invoiceItems);
      }
    },
    formatUnit(value) {
      return value.toLocaleString({ style: "currency" });
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "MNT",
      });
    },
    async actionDialog(condition, id) {
      if (condition == "open") {
        this.invoiceId = id;
        this.displayDelete = true;
      } else {
        if (condition == "yes") {
          // delete contract by Id
          const res = await axios.delete(baseURL + "/" + this.invoiceId);
          if (res.status == 200) {
            const resData = await axios.get(baseURL);
            this.invoiceList = resData.data;
            this.$toast.add({
              severity: "error",
              summary: "Амжилттай устгасан",
              detail: "" + this.invoiceId + "",
              life: 3000,
            });
          }
        }
        this.displayDelete = false;
      }
    },
    async actionModal(type, item) {
      if (type == "new") {
        //add new Contract to the database
        if (this.maxId == null) this.IsFocus = true;
        else this.IsParents = true;
        this.contractDisabled = 0;
        this.disabled = 0;
        this.modalTitle = "Нэхэмжлэх гараар бүртгэх";
        this.displayModal = true;
        this.viewEdit = false;
        this.viewMode = false;
        this.type = "";
        this.price = null;
        this.description = "";
      } else if (type == "save") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        }
      } else if (type == "view") {
        this.IsFocus = false;
        this.viewEdit = false;
        this.viewMode = true;
        this.contractDisabled = 1;
        this.disabled = 1;
        this.modalTitle = "Нэхэмжлэх харах";
        this.type = item.Type;
        this.price = item.Price;
        this.description = item.Description;
        this.displayModal = true;
      } else if (type == "edit") {
        this.IsFocus = false;
        this.viewEdit = true;
        this.viewMode = false;
        this.contractDisabled = 1;
        this.disabled = 0;
        this.modalTitle = "Нэхэмжлэх засварлах";
        this.type = item.Type;
        this.price = item.Price;
        this.description = item.Description;
        this.displayModal = true;
      } else if (type == "update") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        } else {
          const res = await axios.put(baseURL + "/" + this.invoiceId, {
            type: this.type,
            price: this.price,
            description: this.description,
          });
          if (res.status == 201) {
            const resData = await axios.get(baseURL);
            this.invoiceList = resData.data;
            this.modal = false;
            this.displayModal = false;
            this.viewMode = false;
            this.$toast.add({
              severity: "warn",
              summary: "Амжилттай шинэчлэгдсэн",
              detail: "" + this.invoiceId + "",
              life: 3000,
            });
          }
        }
      } else this.displayModal = false;
    },
  },
};
</script>